import type { ViewRecordFieldChange } from '@salescore/client-redux'
import type { ModelSearcher, ViewQueryList, ViewQueryRecordNode } from '@salescore/core'
import { Result } from 'effect'

import { generateDeleteChangesPure } from '../../recoil/records/mutations/upsertViewRecords/generateDeleteChanges'
import type { DeepReadonly } from '../types/DeepReadonly'

interface DestroyRootRecordRight {
  viewRecordFieldChanges: ViewRecordFieldChange[]
  rootRecordNodes: ViewQueryRecordNode[]
}
export interface DestroyRootRecordLeft {
  message: '削除するレコードが見つかりませんでした'
}

export function destroyRootRecord({
  shouldDeleteAllChildren,
  query,
  deletingRecord,
  records,
  modelSearcher,
}: {
  shouldDeleteAllChildren: boolean | undefined
  query: DeepReadonly<ViewQueryList>
  deletingRecord: DeepReadonly<ViewQueryRecordNode>
  records: DeepReadonly<ViewQueryRecordNode[]>
  modelSearcher: ModelSearcher
}): Result.Result<DeepReadonly<DestroyRootRecordRight>, DestroyRootRecordLeft> {
  const deletingRecordIndex = records.findIndex((record) => record.id === deletingRecord.id)
  if (deletingRecordIndex === -1) {
    return Result.fail({
      message: '削除するレコードが見つかりませんでした',
    })
  }
  return Result.succeed({
    viewRecordFieldChanges: generateDeleteChangesPure(
      query,
      query.tree,
      deletingRecord,
      modelSearcher,
      shouldDeleteAllChildren,
    ),
    rootRecordNodes: records.toSpliced(deletingRecordIndex, 1),
  })
}
